export const NO_VALUE = "N/A";
